export default __webpack_public_path__ + "static/media/second-order (2).c94a9e50.png";